player.playerFavoritesModule = {
    // Funkcia sluzi na zobrazenie okna s vyberom ponechat/zmazat oblubene specifikovane podla typu v types
    showFavoritesDeleteModal: function(types) {
        try {
            var errorInfo = "";
            if (types === "sportsLeagues") {
                // Vymazanie oblubenych sportov a lig
                errorInfo = texts.FavoritesDeleteSportsLeagues;
            } else if (types === "events") {
                // Vymazanie oblubenych eventov a chanceType
                errorInfo = texts.FavoritesDeleteEventsECT;
            }
            modal.showInfoModal(2, sets.infoModalTime, true, texts.FavoritesDeleteLabel, errorInfo, false, false, {
                buttonCloseText: texts.FavoritesDeleteCancel,
                buttonCloseAction: "modal.hideInfoModal();",
                button2Text: texts.FavoritesDeleteConfirm,
                button2Action: "player.playerFavoritesModule.deletePlayerFavoriteEntireType('" + types + "')"
            });
        } catch (e) {
            modal.hideInfoModal();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Vymazanie specifikovanych tipov oblubenych
    deletePlayerFavoriteEntireType: function(types) {
        try {
            if (types === "sportsLeagues") {
                // Vymaze oblubene sporty a ligy
                stored.PlayerFavorite.sport = [];
                stored.PlayerFavorite.leagueCup = [];
                $("#userSettingsModal #favoriteSportLeagueDelete").hide();
                modal.hideInfoModal();
                DeletePlayerFavoriteLeagueAndSport();
                main.setPage(1);
            } else if (types === "events") {
                // Vymaze oblubene chanceType
                stored.PlayerFavorite.chanceType = [];
                $("#userSettingsModal #favoriteEventDelete").hide();
                modal.hideInfoModal();
                DeletePlayerFavoriteChanceType();
                main.setPage(1);
            }
        } catch (e) {
            modal.hideInfoModal();
            main.setPage(1);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecuje vyskladavanie struktury pre oblubene v menu
    favoriteStructure: function(data) {
        try {
            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID && stored.PlayerFavorite) {
                if (stored.UserSettings.Original.favoriteSportLeague === "1" && ["sportsBook", "lastMinute", "today", "otherDates"].includes(offer.page)) {
                    stored.allSports = new Object();
                    var allRegions = new Object();
                    var allLeagues = new Object();
                    stored.PlayerFavorite.pFavorites = new Object();
            
                    // Rozdeli whole menu polozky na sporty, regiony a ligy
                    for (d = 0; d < data.length; d++) {
                        if (data[d].Typ === "SP" || data[d].Typ === "FASP") {
                            // Nastavenim skryje pocty udalosti v sporte
                            stored.allSports[data[d].ID] = data[d];
                        } else if (data[d].Typ === "RE") {
                            allRegions[data[d].ID] = data[d];
                        } else if (data[d].Typ === "LC") {
                            allLeagues[data[d].ID] = data[d];
                        }
                    }
        
                    // Prechadza kazdu ligu
                    Object.keys(allLeagues).forEach(function (leagueID, l) {
                        if (regionID = allRegions[allLeagues[leagueID].ParentID].ID) {
                            if (!allRegions[regionID]["allLeagues"]) {
                                allRegions[regionID]["allLeagues"] = new Array();
                            }
                            // Priradi do konkretneho regionu vsetky ligy
                            allRegions[regionID].allLeagues.push(allLeagues[leagueID]);
            
                            // Priradi do konkretneho regionu len oblubene ligy
                            if (stored.PlayerFavorite.leagueCup.includes(allLeagues[leagueID].ID) && !stored.PlayerFavorite.sport.includes(allRegions[regionID].ParentID)) {
                                if (!allRegions[regionID]["playerLeagues"]) {
                                    allRegions[regionID]["playerLeagues"] = new Object();
                                }
                                allRegions[regionID].playerLeagues[allLeagues[leagueID].ID] = Object.assign({},allLeagues[leagueID]);
                            }
                        }
                    });

                    // Prechadza kazdy (uz ligami naplneny) region
                    Object.keys(allRegions).forEach(function (regionID, r) {
                        if (sportID = allRegions[regionID].ParentID) {
                            if (!stored.allSports[sportID]["allRegions"]) {
                                stored.allSports[sportID]["allRegions"] = new Array();
                            }
                            // Priradi do konkretneho sportu vsetky (uz ligami naplnene regiony) regiony
                            stored.allSports[sportID].allRegions.push(allRegions[regionID]);

                            if (!stored.allSports[sportID].allLeaguesFlat) {
                                stored.allSports[sportID].allLeaguesFlat = new Array();
                            }
        
                            // Priradi do konkretneho sportu vsetky ligy daneho sportu (jednorozmerne pole)
                            stored.allSports[sportID].allLeaguesFlat.push(allRegions[regionID].allLeagues);
                            stored.allSports[sportID].allLeaguesFlat = stored.allSports[sportID].allLeaguesFlat.reduce(function(a, b) {
                                return a.concat(b);
                            }, []);

                            // Priradi do oblubenych len sporty ktore obsahuju oblubene ligy
                            if (allRegions[regionID].playerLeagues) {
                                if (!stored.PlayerFavorite.pFavorites[sportID]) {
                                    stored.PlayerFavorite.pFavorites[sportID] = stored.allSports[sportID];
                                }
                                if (!stored.PlayerFavorite.pFavorites[sportID].playerLeagues) {
                                    stored.PlayerFavorite.pFavorites[sportID].playerLeagues = new Object();
                                }
                                $.extend(stored.PlayerFavorite.pFavorites[sportID].playerLeagues, allRegions[regionID].playerLeagues);
                            }
                        }
                    });

                    // Priradi do oblubenych len oblubene sporty
                    Object.keys(stored.allSports).forEach(function(sportID) {
                        if (stored.PlayerFavorite.sport.includes(stored.allSports[sportID].ID)) {
                            stored.PlayerFavorite.pFavorites[sportID] = stored.allSports[sportID];
                        }
                    });

                    if (player.playerFavoritesModule.favoriteButtonState("menuButtonFav") && !$.isEmptyObject(stored.PlayerFavorite.pFavorites)) {
                        // Neprazdne oblubene (sporty/ligy)
                        $("#sportsBook #FA0").show();
                    } else {
                        $("#sportsBook #FA0").hide();
                    }
                } else {
                    $("#sportsBook #FA0").hide();
                }

                if (stored.UserSettings.Original.favoriteEvent === "1") {
                    (stored.PlayerFavorite.sport.length || stored.PlayerFavorite.leagueCup.length? $("#userSettingsModal #favoriteSportLeagueDelete").show(): $("#userSettingsModal #favoriteSportLeagueDelete").hide());
                    (stored.PlayerFavorite.chanceType.length? $("#userSettingsModal #favoriteEventDelete").show(): $("#userSettingsModal #favoriteEventDelete").hide());
                }
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na pridavanie/odoberanie oblubenych
    editPlayerFavorite: function(sportID, leagueID, eventID, chanceType, liveBet) {
        try {
            // Flag na zabranenie zobrazenia detailu zapasu
            stored.favoriteBtnTrigger = true;
            var favoriteEctIndex = -1;
            var actionAdd;
            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                // Prihlaseny player, zmena stavu v oblubenych
                var favoriteType, favoriteId;
                if (chanceType) {
                    favoriteType = stored.favTypes.chanceType;
                    favoriteId = chanceType;
                    favoriteEctIndex = stored.PlayerFavorite.chanceType.findIndex(function(ect) {
                        return (ect.sportId === sportID && ect.chanceTypeId === chanceType && ect.liveBetting === liveBet);
                    });
                } else if (eventID) {
                    favoriteType = stored.favTypes.event;
                    favoriteId = eventID;
                } else if (leagueID) {
                    favoriteType = stored.favTypes.leagueCup;
                    favoriteId = leagueID;
                } else if (sportID) {
                    favoriteType = stored.favTypes.sport;
                    favoriteId = sportID;
                } else {
                    return false;
                }
                // NativeApp miesto prazdneho pola vracia null
                if (stored.PlayerFavorite && stored.PlayerFavorite[favoriteType].includes(favoriteId) || favoriteEctIndex !== -1) {
                    actionAdd = false;
                    // Odobranie z oblubenych
                    if (favoriteEctIndex !== -1) {
                        // Odobratie chanceType
                        stored.PlayerFavorite.chanceType.splice(favoriteEctIndex, 1);
                    } else {
                        stored.PlayerFavorite[favoriteType] = stored.PlayerFavorite[favoriteType].filter(function(favId) {
                            if (favoriteId !== favId) {
                                return favId;
                            }
                        });
                    }
                    $(event.currentTarget).removeClass("enabled");
                    try {
                        if (favoriteEctIndex !== -1) {
                            DeletePlayerFavorite(favoriteType, favoriteId, sportID, liveBet? "1": "0");
                        } else {
                            DeletePlayerFavorite(favoriteType, favoriteId);
                        }
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    }
                } else {
                    actionAdd = true;
                    // Pridanie do oblubenych, blinkutie Oblubenych
                    if ((sets.favoriteMaxSports || sets.favoriteMaxLeagues)) {
                        if (favoriteType === stored.favTypes.sport && stored.PlayerFavorite.sport.length >= sets.favoriteMaxSports) {
                            modal.showErrObj(2, 5, {err1: texts.FavoritesMaxSports, errType: "FavoritesMaxSports"});
                            return false;
                        } else if (favoriteType === stored.favTypes.leagueCup && stored.PlayerFavorite.leagueCup.length >= sets.favoriteMaxLeagues) {
                            modal.showErrObj(2, 5, {err1: texts.FavoritesMaxLeagues, errType: "FavoritesMaxLeagues"});
                            return false;
                        }
                    }
                    var menuFavoriteStar = $("#sportsBook #FA0 .sport-icon-0").addClass("blink");
                    setTimeout(function() {
                        menuFavoriteStar.removeClass("blink");
                    }, 1000);

                    $(event.currentTarget).addClass("enabled");

                    try {
                        if (favoriteType === stored.favTypes.chanceType) {
                            // Pridanie chanceType
                            var favoriteECT = {
                                sportId: sportID,
                                chanceTypeId: chanceType,
                                liveBetting: $("#event #chances").attr("live-betting") === "Y"? true: false
                            };
                            stored.PlayerFavorite[favoriteType].push(favoriteECT);
                            AddPlayerFavorite(favoriteType, favoriteId, favoriteECT.sportId, (favoriteECT.liveBetting? "1": "0"));
                        } else {
                            stored.PlayerFavorite[favoriteType].push(favoriteId);
                            AddPlayerFavorite(favoriteType, favoriteId);
                        }
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    }
                }
                player.playerFavoritesModule.favoriteStructure(stored.allMenu);
                if (favoriteType === stored.favTypes.chanceType) {
                    // Jedna sa o zmenu oblubenej chanceType
                    stored.detailActiveTab = offer.groupActive;
                    service.loadPure("sportsBookEventDetail", null, true);
                    return true;
                } else if (favoriteType === stored.favTypes.event) {
                    // Jedna sa o zmenu oblubenej udalosti
                    shared.scrollModule.scrollReload("sportsBookEvents", "save");
                    if (stored.PlayerFavorite.event.length) {
                        service.loadPure('sportsBookEvents', null, true, true);
                    } else {
                        service.loadPure('sportsBookEvents', null, true);
                    }
                    return true;
                }

                if (favoriteType === stored.favTypes.sport || favoriteType === stored.favTypes.leagueCup) {
                    // Jedna sa o zmenu oblubeneho sportu alebo ligy
                    if (offer.favSportID && offer.favSportID !== -1) {
                        // Menu oblubene
                        if (player.playerFavoritesModule.favoriteButtonState("menuButtonFav") && !$.isEmptyObject(stored.PlayerFavorite.pFavorites)) {
                            $("#sportsBook #FA0").show();
                            shared.scrollModule.scrollReload("sportsBookEventsFavorites", "save");
                            if (offer.pointer === "FA0" || (!stored.PlayerFavorite.pFavorites[sportID] && (offer.pointer.split("FASP")[1]) || (offer.pointer.replace(/\d/g, '') === "LC"))) {
                                // Presmeruje na menu oblubene
                                service.loadPure("sportsBookRegions", "FA0");
                            } else if (offer.pointer.split("FASP")[1]) {
                                // Presmeruje na menu oblubeny sport
                                service.loadPure("sportsBookLeagues", offer.pointer);
                            } else if (offer.pointer.replace(/\d/g, '') === "LC" || offer.pointer.replace(/\d/g, '') === "LX") {
                                // Odstranenie sportu/ligy z menu ligy
                                service.loadPure("sportsBookLeagues", "FASP" + offer.sportID);
                            }
                            return true;
                        } else {
                            // Skryje sekciu oblubene v menu
                            $("#sportsBook #FA0").hide();
                            offer.pointer = offer.SeSpID = null;
                            offer.sportEventID = offer.sportID = offer.regionID = offer.leagueCupID = -1;
                            // Ak sa nachadza v Oblubenych v menu, nastav default kurzovu ponuku (bez vybraneho sportu)
                            switch (offer.page) {
                                case "lastMinute":
                                    main.setPage(4);
                                break;
                                case "today":
                                    main.setPage(5);
                                break;
                                case "otherDates":
                                    main.setPage(6);
                                break;
                                default:
                                    main.setPage(2);
                                break;
                            }
                        }
                    } else {
                        if (favoriteType === stored.favTypes.sport) {
                            var leagues = $("#events").find("[sport-id='SP" + sportID + "']").find(".favorite-event");
                            if (actionAdd? leagues.addClass("hidden"): leagues.removeClass("hidden"));
                        } else if (favoriteType === stored.favTypes.leagueCup) {
                            var league = $("#events #LC" + leagueID);
                            if (actionAdd? league.removeClass("hidden"): league.addClass("hidden"));
                        }
                    }
                }
                return true;
            } else {
                // Neprihlaseny player, zobrazi hlasku o nedostupnosti oblubenych pre neprihlaseho
                modal.showInfoModal(3, 0, true, texts.FavoritesUnsigned, texts.FavoritesUnsignedInfo, false, false, {
                    buttonCloseText: texts.ConfirmButtonOK,
                    buttonCloseAction: "modal.hideInfoModal();"
                });
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spustenie volani na backend pre jednotlive sporty/ligy
    resolveFavoritesCall: function(sportsID) {
        try {
            stored.PlayerFavorite.sportLeagueCupCount = 0;
            sportsID.forEach(function(sID) {
                offer.sportID = offer.leagueCupID = -1;
                if (leagues = stored.PlayerFavorite.pFavorites[sID].playerLeagues) {
                    Object.keys(leagues).forEach(function(lID) {
                        offer.sportID = parseInt(sID);
                        offer.leagueCupID = lID;
                        stored.PlayerFavorite.sportLeagueCupCount++;
                        service.loadPure("sportsBookEventsFavorites", undefined, undefined, offer.loadAll);
                        offer.leagueCupID = -1;
                    });
                } else {
                    offer.sportID = parseInt(sID);
                    stored.PlayerFavorite.sportLeagueCupCount++;
                    service.loadPure("sportsBookEventsFavorites", undefined, undefined, offer.loadAll);
                }
            });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spojenie postupne prichadzajucich sportov/lig z offery
    composeSports: function(favoriteSports) {
        try {
            var eventsTempData = {
                EventChanceTypes: [],
                Odds: {},
                Labels: {},
                BetradarTeams: {},
                LocalizedTips: {},
                RelatedEvents: {}
            };
            // Favorite sports - obsahuje sporty aj samostatne ligy
            favoriteSports.forEach(function(sportID) {
                if (stored.PlayerFavorite.pFavorites[sportID].playerLeaguesData) {
                    // Ligy
                    Object.values(stored.PlayerFavorite.pFavorites[sportID].playerLeagues).sort(function(leagueA, leagueB) {
                        return leagueA.Order - leagueB.Order;
                    }).forEach(function(league) {
                        player.playerFavoritesModule.composeEvents(stored.PlayerFavorite.pFavorites[sportID].playerLeaguesData[league.ID], eventsTempData);
                    });

                } else if (stored.PlayerFavorite.pFavorites[sportID].allData) {
                    // Sporty
                    stored.PlayerFavorite.sport.filter(function(sportID) {
                        return Object.keys(stored.PlayerFavorite.pFavorites).includes(String(sportID)) && stored.PlayerFavorite.pFavorites[sportID].allData;
                    }).forEach(function(sportID) {
                        player.playerFavoritesModule.composeEvents(stored.PlayerFavorite.pFavorites[sportID].allData, eventsTempData);
                    });
                }
            });
            return eventsTempData;
        } catch (e) {
            $("#sportsBook").removeClass("ui-disabled");
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "composeEventsError", "favoriteSports: " + JSON.stringify(favoriteSports));
            return false;
        }
    },

    // Funkcia na spojenie postupne prichadzajucich zapasov do jedneho objektu (akoby boli naraz prijate z offery)
    composeEvents: function(from, to) {
        try {
            to.EventChanceTypes = to.EventChanceTypes.concat(from.EventChanceTypes);
            to.Odds = $.extend(to.Odds, from.Odds);
            to.Labels = $.extend(to.Labels, from.Labels);
            to.BetradarTeams = $.extend(to.BetradarTeams, from.BetradarTeams);
            to.LocalizedTips = $.extend(to.LocalizedTips, from.LocalizedTips);
            to.RelatedEvents = $.extend(to.RelatedEvents, from.RelatedEvents);
        } catch (e) {
            $("#sportsBook").removeClass("ui-disabled");
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "composeEventsError", "from: " + JSON.stringify(from) + " to: " + JSON.stringify(to));
            return false;
        }
    },

    /**
     *
     * Funkcia rozhoduje o zobrazeni/nezobrazeni/stave tlacidla oblubene
     *
     * @param type                 O aky typ buttonu sa jedna (stored.favTypes)
     * @param sportID              sportID ktoremu tlacitko oblubene prislucha
     * @param leagueCupID          leagueCupID ktoremu tlacitko oblubene prislucha
     * @param eventID              eventID ktoremu tlacitko oblubene prislucha
     * @param chanceTypeID         chanceTypeID ktoremu tlacitko oblubene prislucha
     * @returns {(boolean|string)} false - nema sa zobrazit, "disabled" - nieje zaznam o ulozeni v oblubenych, "enabled" - nachadza sa v oblubenych
     */
    favoriteButtonState: function(type, sportID, leagueCupID, eventID, chanceTypeID, liveBetting) {
        try {
            if (!profile.Favorite || !stored.UserSettings) {
                return false;
            } else if (stored.UserSettings.Original &&
                ((stored.UserSettings.Original.favoriteEvent === "0" && (type === stored.favTypes.event || type === stored.favTypes.chanceType)) ||
                (stored.UserSettings.Original.favoriteSportLeague === "0" && (type === stored.favTypes.sport || type === stored.favTypes.leagueCup)))) {
                    return false;
            } else if (type === "sport" && (!["sportsBook", "lastMinute", "today", "otherDates"].includes(offer.page) || sportID === 54)) {
                return false;
            }
            var favoriteButtonState = "disabled";
            switch(type) {
                case "menuButtonFav":
                    if (["sportsBook", "lastMinute", "today", "otherDates"].includes(offer.page) && stored.PlayerFavorite && (stored.PlayerFavorite.leagueCup.length || stored.PlayerFavorite.sport.length)) {
                        return true;
                    }
                    return false;
                break;
                case stored.favTypes.sport:
                    if (offer.page !== "results" && stored.redirectTo !== "results" && offer.sportID !== offer.vgID && offer.onlyLive !== 1) {
                        if (stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.sport].includes(sportID)) {
                            favoriteButtonState = "enabled";
                        }
                        return favoriteButtonState;
                    }
                    return "hidden"
                break;
                case stored.favTypes.leagueCup:
                    if (offer.page !== "results" && stored.redirectTo !== "results" && offer.sportID !== offer.vgID && !stored.isFavoriteRender) {
                        // Zakladne podmienky pre zobrazenie buttonu oblubene vyplyvajuce z miesta kde sa maju zobrazit
                        if (offer.onlyLive === -1 && (!stored.PlayerID || (stored.PlayerID && stored.PlayerFavorite && stored.PlayerFavorite.sport && !stored.PlayerFavorite.sport.includes(sportID)))) {
                            // Dalsie podmienky
                            if (stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.leagueCup].includes(leagueCupID)) {
                                favoriteButtonState = "enabled";
                            }
                            return favoriteButtonState;
                        }
                    }
                    if (stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.leagueCup].includes(leagueCupID)) {
                        favoriteButtonState = "enabled";
                    }
                    return favoriteButtonState + " hidden";
                break;
                case stored.favTypes.event:
                    if (offer.onlyLive === 1) {
                        // Oblubene zapasay je mozne pridat len v LIVE
                        if (stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.event].includes(eventID)) {
                            favoriteButtonState = "enabled";
                        }
                        return favoriteButtonState;
                    }
                break;
                case stored.favTypes.chanceType:
                    favoriteButtonState = " disabled";
                    isEnabled = stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.chanceType].some(function(ect) {
                        // Ak sa jedna o dany sport, chanceType, a sedi live betting
                        return (ect.sportId === sportID && ect.chanceTypeId === chanceTypeID && ect.liveBetting === liveBetting);
                    })
                    if (isEnabled) {
                        favoriteButtonState = " enabled";
                    }
                    return favoriteButtonState;
                break;
                default:
                    return false;
                break;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
